import { useMemo } from 'react';

import AccordionToggleNew from 'approot/shared/accordion/accordion-toggle-new';
import LessonMaterialsList from 'approot/shared/lesson-materials/lesson-materials-list';
import type { LessonMaterialFragment } from '../../../../shared/lesson-materials/lesson-material-fragment.generated';

const LessonMaterialsView = ({
  materials,
  title,
  displayExpanded,
}: {
  materials: LessonMaterialFragment[] | null;
  title: string;
  displayExpanded?: boolean;
}) => {
  const filteredMaterials = useMemo(
    () => materials?.filter(m => !!m.name.trim()) || [],
    [materials]
  );

  return filteredMaterials.length ? (
    <AccordionToggleNew
      title={title}
      withDividers
      displayExpanded={displayExpanded}
    >
      <LessonMaterialsList list={filteredMaterials} />
    </AccordionToggleNew>
  ) : null;
};

export default LessonMaterialsView;
